import { motion } from "framer-motion";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Mehmet K.",
    place: "Selçuklu",
    tag: "Gece çekici",
    text: "Gece 02:30'da Konya yolu üzerinde kaldım. Telefonu açtım, uzun uzun hikayemi dinletmeden yerimi sordu. 20 dakikada gelip aracımı aldı. Emeğine sağlık Adem abi.",
  },
  {
    name: "Ayşe D.",
    place: "Konya → Ankara",
    tag: "İl dışı çekici",
    text: "Ankara'ya giderken araç arıza yaptı. Hem güler yüzlü hem güven veren biri; araç hasarsız teslim edildi. İl dışı çekici için tereddütsüz önereceğim bir numara.",
  },
  {
    name: "Hasan Y.",
    place: "Akşehir",
    tag: "Akü takviye",
    text: "Sabah işe gidemez oldum, akü bitmişti. Aradım, dakikasında geldi ve akü takviye yaptı. Fiyat da telefonda söylediği gibiydi, sürpriz yok.",
  },
  {
    name: "Emre T.",
    place: "Meram",
    tag: "Lastik değişimi",
    text: "Lastik patladı, stepne yoktu. Yerinde lastik değişimi yaptılar, yola tekrar çıktım. Kibar ve profesyonel bir hizmet, herkese tavsiye ederim.",
  },
];

function Stars() {
  return (
    <div className="flex gap-1" aria-label="5 üzerinden 5 yıldız">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className="w-4 h-4 text-brand-amber fill-brand-amber" strokeWidth={0} />
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section id="yorumlar" data-testid="testimonials-section" className="py-16 lg:py-24 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6 }}
          className="mb-10 lg:mb-14 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4"
        >
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Müşteri Yorumları</p>
            <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-3 leading-[0.95]">
              Yolda kalanlar
              <br />
              <span className="text-outline">ne diyor?</span>
            </h2>
          </div>
          <p className="text-sm text-slate-400 max-w-xs">
            Konya'nın dört bir yanından, günün her saatinde ulaşan müşterilerimizin değerlendirmeleri.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {REVIEWS.map((r, i) => (
            <motion.figure
              key={r.name}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              data-testid={`testimonial-card-${i}`}
              className="rounded-2xl border border-white/10 bg-night-800/60 p-6 flex flex-col h-full hover:border-brand/50 hover:-translate-y-1 transition-all duration-300"
            >
              <Stars />
              <blockquote className="text-sm text-slate-300 leading-relaxed mt-4 flex-1">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-white/10 flex items-center justify-between gap-2">
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-brand/20 border border-brand/40 text-brand font-display font-bold flex items-center justify-center" aria-hidden="true">
                    {r.name.charAt(0)}
                  </span>
                  <div>
                    <p className="text-sm font-bold text-white">{r.name}</p>
                    <p className="text-xs text-slate-500">{r.place}</p>
                  </div>
                </div>
                <span className="text-[10px] uppercase tracking-widest text-brand border border-brand/40 rounded-full px-2 py-1">
                  {r.tag}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
